import { createSlice } from '@reduxjs/toolkit';

const name = 'teamsModal';

const initialState = {
  isOpen: false,
};

const teamsModal = createSlice({
  name,
  initialState,
  reducers: {
    onOpen: (state) => {
      state.isOpen = true;
    },
    onClose: (state) => {
      state.isOpen = false;
    },
  },
});

export const { actions } = teamsModal;

export default teamsModal.reducer;
